import Button, { ButtonProps } from "../_Button";

import styles from "./SecondaryButton.module.scss";

type SecondaryButtonProps = ButtonProps & {
  color?: "green" | "white" | "blue";
};

function SecondaryButton({
  className,
  color = "green",
  ...props
}: SecondaryButtonProps) {
  return (
    <Button
      className={[styles.secondary, styles[color], className].join(" ")}
      {...props}
    />
  );
}

SecondaryButton.Icon = Button.Icon;

export default SecondaryButton;
